// JsaHazardsV2
export class JsaHazardsV2 {
  constructor(data = {}) {
    this.aerialLiftPlatform = data.aerial_lift_platform || false;
    this.chemBurns = data.chem_burns || false;
    this.chemSplash = data.chem_splash || false;
    this.cse = data.cse || false;
    this.cutAbrasion = data.cut_abrasion || false;
    this.demo = data.demo || false;
    this.electrical = data.electrical || false;
    this.elevatedLoad = data.elevated_load || false;
    this.ergonomics = data.ergonomics || false;
    this.explosionFire = data.explosion_fire || false;
    this.eyeHazFlyingObj = data.eye_haz_flying_obj || false;
    this.fallMoreSixFt = data.fall_more_six_ft || false;
    this.heatColdStress = data.heat_cold_stress || false;
    this.heavyEquipment = data.heavy_equipment || false;
    this.inhalationHaz = data.inhalation_haz || false;
    this.manualLift = data.manual_lift || false;
    this.noise = data.noise || false;
    this.overheadElecHaz = data.overhead_elec_haz || false;
    this.overexertion = data.overexertion || false;
    this.pinchPoint = data.pinch_point || false;
    this.poisonPlantInsect = data.poison_plant_insect || false;
    this.pressureLineEquip = data.pressure_line_equip || false;
    this.radiation = data.radiation || false;
    this.sharpObj = data.sharp_obj || false;
    this.slipTripFall = data.slip_trip_fall || false;
    this.spills = data.spills || false;
    this.thermalBurns = data.thermal_burns || false;
    this.trenchExcavCavein = data.trench_excav_cavein || false;
    this.waterHaz = data.water_haz || false;
    this.weatherCond = data.weather_cond || false;
    this.weldCutting = data.weld_cutting || false;
    this.other = data.other || false;
    this.otherDescribe = data.other_describe || "";
  }

  updateAttribute(attribute, value) {
    this[attribute] = value;
  }

  updateOtherDescribe(value) {
    this.otherDescribe = value;
  }

  // Helper function to convert camelCase to snake_case
  setSnakeCaseField(field) {
    return field.replace(/([A-Z])/g, "_$1").toLowerCase();
  }

  // To json for sending to the database
  toJson() {
    return {
      aerial_lift_platform: this.aerialLiftPlatform,
      chem_burns: this.chemBurns,
      chem_splash: this.chemSplash,
      cse: this.cse,
      cut_abrasion: this.cutAbrasion,
      demo: this.demo,
      electrical: this.electrical,
      elevated_load: this.elevatedLoad,
      ergonomics: this.ergonomics,
      explosion_fire: this.explosionFire,
      eye_haz_flying_obj: this.eyeHazFlyingObj,
      fall_more_six_ft: this.fallMoreSixFt,
      heat_cold_stress: this.heatColdStress,
      heavy_equipment: this.heavyEquipment,
      inhalation_haz: this.inhalationHaz,
      manual_lift: this.manualLift,
      noise: this.noise,
      overhead_elec_haz: this.overheadElecHaz,
      overexertion: this.overexertion,
      pinch_point: this.pinchPoint,
      poison_plant_insect: this.poisonPlantInsect,
      pressure_line_equip: this.pressureLineEquip,
      radiation: this.radiation,
      sharp_obj: this.sharpObj,
      slip_trip_fall: this.slipTripFall,
      spills: this.spills,
      thermal_burns: this.thermalBurns,
      trench_excav_cavein: this.trenchExcavCavein,
      water_haz: this.waterHaz,
      weather_cond: this.weatherCond,
      weld_cutting: this.weldCutting,
      other: this.other,
      other_describe: this.otherDescribe,
    };
  }

  // Helper for single and multi-field patches to be sent via websocket
  toPatch(fields, jsaId, action = "update") {
    const patch = {
      patch_type: "jsa_hazards_v2",
      jsa_id: jsaId,
      action,
    };

    for (const [key, value] of Object.entries(fields)) {
      const snakeCaseField = this.setSnakeCaseField(key);
      patch[snakeCaseField] = value;
    }

    return patch;
  }
}
